import { get as lodashGet, has as lodashHas, set as lodashSet } from 'lodash';
import { assign, AssignMeta } from 'xstate';
import { AppStateMachineContext, AppStateMachineEvent } from '../types';

export type MergeAction = {
  action: {
    params: {
      merge: string[][];
    };
  };
} & AssignMeta<AppStateMachineContext, AppStateMachineEvent>;

const isActionMergeEvent = (
  metaObj: AssignMeta<AppStateMachineContext, AppStateMachineEvent>,
): metaObj is MergeAction => lodashHas(metaObj, 'action.params.merge');

export const assignAction = (
  context: AppStateMachineContext,
  meta: AssignMeta<AppStateMachineContext, AppStateMachineEvent>,
) => {
  if (isActionMergeEvent(meta)) {
    const contextCopy = { ...context };

    meta.action.params.merge.forEach(([to, from]) => {
      lodashSet(contextCopy, to, lodashGet(context, from));
    });

    return contextCopy;
  }

  return context;
};

export const saveDataFrom = assign<
AppStateMachineContext, AppStateMachineEvent
>((context, _event, meta) => assignAction(context, meta));
